import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'sm-view-documents-details',
  templateUrl: './view-documents-details.component.html',
  styleUrls: ['./view-documents-details.component.scss']
})
export class ViewDocumentsDetailsComponent implements OnInit {

  constructor( @Inject(MAT_DIALOG_DATA) public parentData: any,) { }

  ngOnInit(): void {
  }

}
